import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationDataService } from './services/application-data.service';
import { AlwaysAuthGuard } from './router-guard';
import { LoginComponent } from './login/login.component';
import { ProjectListComponent } from './project-list/project-list.component';
import { UserCreationComponent } from './user-creation/user-creation.component';
import { ProjectDashboardComponent } from './project-dashboard/project-dashboard.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NoPermissionComponent } from './no-permission/no-permission';
import { ProjectDetailsComponent } from './project-details/project-details.component';
import { MasterCreationComponent } from './master-creation/master-creation.component';
import { FormconfigurationComponent } from './form-configuration/form-configuration.component';
import { DynamicEntryFormComponent } from './dynamic-entry-form/dynamic-entry-form.component';
import { FormListComponent } from './form-list/form-list.component';
import { FormReportsComponent } from './form-reports.component/form-reports.component';
import { ProjectAnalytics1 } from './project-analytics-1/project-analytics-1';

export const routes: Routes = [
  {
    path: 'login', component: LoginComponent,
    pathMatch: 'full',
    resolve: {
      env: ApplicationDataService,
    }
  },
  {
    path: 'project_dashboard', component: ProjectDashboardComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'dashboard_view', component: ProjectListComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'user_creation', component: UserCreationComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'master_creation', component: MasterCreationComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'form_configuration', component: FormconfigurationComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'form_submission', component: DynamicEntryFormComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'form_list', component: FormListComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'form_reports', component: FormReportsComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'entry_form', component: DynamicEntryFormComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'project_details', component: ProjectDetailsComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'project_analytics', component: ProjectAnalytics1,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  {
    path: 'reset_password', component: ResetPasswordComponent,
    canActivate: [AlwaysAuthGuard],
    resolve: {
      env: ApplicationDataService
    },
  },
  { path: 'no-permission', component: NoPermissionComponent },
  { path: '**', redirectTo: 'login' },
  { path: '', redirectTo: '/login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled'
  })],
  providers: [ApplicationDataService, AlwaysAuthGuard],
  exports: [RouterModule]
})
export class AppRoutingModule { }
